import { Users, ScrollText, CreditCard, Receipt, Settings } from "lucide-react";
import { Outlet, useLocation } from "react-router-dom";

import Sidebar from "../common/sidebar/Sidebar";
import SidebarItem from "../common/sidebar/SidebarItem";

const menuItems = [
  {
    key: "clients",
    label: "Clients",
    icon: <Users size={18} />,
    to: "clients",
  },
  {
    key: "contracts",
    label: "Contracts",
    icon: <ScrollText size={18} />,
    to: "contracts",
  },
  {
    key: "invoices",
    label: "Invoices",
    icon: <Receipt size={18} />,
    to: "invoices",
  },
  {
    key: "payments",
    label: "Payments",
    icon: <CreditCard size={18} />,
    to: "payments",
  },
  {
    key: "settings",
    label: "Settings",
    icon: <Settings size={18} />,
    to: "settings",
  },
];

export default function Billing() {
  const location = useLocation();
  const isSettingsRoute = location.pathname.includes("/settings");

  const contentClasses = isSettingsRoute
    ? "flex-1"
    : "flex-1 bg-white rounded-2xl shadow-md p-6";

  return (
    <div className="w-full h-full flex gap-8 px-12 py-8 bg-gray-50">
      {/* Sidebar */}
      <Sidebar>
        {menuItems.map((item) => (
          <SidebarItem
            key={item.key}
            to={item.to}
            icon={item.icon}
            label={item.label}
          />
        ))}
      </Sidebar>

      <div className={contentClasses}>
        <Outlet />
      </div>
    </div>
  );
}
